/* ============================================================
   THE ARA ATELIER — renderer and interactions
   Copy lives in content.js. This file builds, animates and wires.
   ============================================================ */
(function () {
  "use strict";

  /* ---- the one setting that turns the site on -------------------------
     ARA_API is the address of the Ara Worker. It runs two things: the
     customization form (with its picture attachment) and Pamela.

     Paste the Worker url below, or set window.ARA_API before this script
     loads — the Shopify theme does that, so the address lives in the theme
     and not in this file.

       var ARA_API = "https://ara-atelier.<your-subdomain>.workers.dev";

     Left empty, the site still works: the form falls back to opening the
     visitor's mail app with everything filled in, and Pamela says she is
     offline rather than pretending.                                      */
  var ARA_API = (window.ARA_API || "").replace(/\/+$/, "");

  var INBOX = "info@thearaatelier.com";
  var SUBJECT = "Website Inquiry";
  var TIKTOK = "the_ara_atelier";

  var C = window.ARA_CONTENT, COLORS = window.ARA_COLORS, CUTS = window.ARA_CUTS;
  CUTS.forEach(function (c, i) { c._i = i; });   /* catalog position — drives the photo filename */
  var lang = "en";
  var color = COLORS[0], fShape = "all", step = 0;
  var t = function () { return C[lang]; };
  var $ = function (id) { return document.getElementById(id); };
  var esc = function (s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;"); };
  var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  function A(n) { return (window.ARA_ASSETS && window.ARA_ASSETS[n]) || ("assets/" + n); }

  /* ------------------------------------------------------------------
     WHERE THE PAGES LIVE

     The site is one set of files locally and a set of Shopify pages in
     production, so nothing in the copy or the renderers knows a URL —
     they know a page KEY, and this resolves it. theme.liquid sets
     window.ARA_URLS; without it the local filenames are used, which is
     what makes the folder openable straight off a disk.
     ------------------------------------------------------------------ */
  var LOCAL_URLS = {
    home: "index.html", book: "book.html", diamond: "diamond.html",
    custom: "custom.html", worn: "worn.html", vault: "vault.html",
    house: "about.html", careers: "careers.html", journal: "journal.html",
    contact: "contact.html"
  };
  /* which key this page is — the nav marks it, and it never links to itself */
  var HERE = (document.getElementById("nav") || {}).dataset
    ? document.getElementById("nav").dataset.page : "home";
  function P(k) {
    var u = (window.ARA_URLS && window.ARA_URLS[k]) || LOCAL_URLS[k] || LOCAL_URLS.home;
    return u + (lang === "es" ? (u.indexOf("?") > -1 ? "&" : "?") + "lang=es" : "");
  }
  /* the seven that sit in the bar; the rest live in the drawer and footer */
  var NAV_MAIN = ["book", "diamond", "custom", "vault", "journal", "house", "contact"];
  var NAV_MORE = ["worn", "careers"];

  /* Photography that is not a cut tile — hero, up close, the ring, the six
     steps. SCENE is written by tools-build-stones.py as each frame lands;
     until then every call falls back to the placeholder it names, so the
     page is never missing an image.                                        */
  var SCENE = window.ARA_SCENE || {};
  function has(n) { return !!SCENE[n]; }
  function S(n, fallback) { return has(n) ? A("scene/" + SCENE[n]) : A(fallback); }

  /* split a heading into per-word reveal spans */
  function words(html) {
    return html.split(/(<br>|<em>|<\/em>)/).map(function (chunk) {
      if (/^</.test(chunk)) return chunk;
      var lead = /^\s/.test(chunk) ? " " : "", tail = /\s$/.test(chunk) ? " " : "";
      return lead + chunk.split(" ").filter(Boolean).map(function (w) {
        return '<span class="w"><i>' + w + "</i></span>";
      }).join(" ") + tail;
    }).join("");
  }
  function head(eyebrow, h, body) {
    return '<div class="sec-head"><div><p class="eyebrow">' + eyebrow +
      '</p><h2 class="display">' + words(h) + "</h2></div>" +
      (body ? '<p class="body-copy">' + body + "</p>" : "<div></div>") + "</div>";
  }

  /* ============================================================
     DIAMOND DIAGRAMS
     Every cut is sampled off its own outline, then faceted the way
     that family of cut is actually faceted.
     ============================================================ */
  var NS = "http://www.w3.org/2000/svg", HOST = null, N = 48;
  function host() {
    if (HOST) return HOST;
    HOST = document.createElementNS(NS, "svg");
    HOST.setAttribute("width", "0"); HOST.setAttribute("height", "0");
    HOST.setAttribute("aria-hidden", "true");
    HOST.style.cssText = "position:absolute;width:0;height:0;overflow:hidden";
    document.body.appendChild(HOST);
    return HOST;
  }
  function outlineEl(c) {
    var el;
    if (c.e) {
      el = document.createElementNS(NS, "ellipse");
      el.setAttribute("cx", 50); el.setAttribute("cy", 60);
      el.setAttribute("rx", c.e[0]); el.setAttribute("ry", c.e[1]);
    } else if (c.p) {
      el = document.createElementNS(NS, "polygon");
      el.setAttribute("points", c.p);
    } else {
      el = document.createElementNS(NS, "path");
      el.setAttribute("d", c.d);
    }
    return el;
  }
  var PTS = {};
  function pts(c) {
    var key = c.en;
    if (PTS[key]) return PTS[key];
    var el = outlineEl(c), out = [], i, p, L;
    host().appendChild(el);
    try {
      L = el.getTotalLength();
      for (i = 0; i < N; i++) { p = el.getPointAtLength(L * i / N); out.push([p.x, p.y]); }
    } catch (_) {
      for (i = 0; i < N; i++) {
        var a = Math.PI * 2 * i / N;
        out.push([50 + 42 * Math.cos(a), 60 + 48 * Math.sin(a)]);
      }
    }
    host().removeChild(el);
    PTS[key] = out;
    return out;
  }
  function sc(p, k) { return [50 + (p[0] - 50) * k, 60 + (p[1] - 60) * k]; }
  function ring(P, k) {
    return '<polygon class="facet" points="' + P.map(function (p) {
      var q = sc(p, k); return q[0].toFixed(1) + "," + q[1].toFixed(1);
    }).join(" ") + '"></polygon>';
  }
  function spokes(P, k1, k2, every, offset) {
    var out = "", i, a, b;
    for (i = offset || 0; i < P.length; i += every) {
      a = sc(P[i], k1); b = sc(P[i], k2);
      out += '<line class="facet" x1="' + a[0].toFixed(1) + '" y1="' + a[1].toFixed(1) +
        '" x2="' + b[0].toFixed(1) + '" y2="' + b[1].toFixed(1) + '"></line>';
    }
    return out;
  }
  function star(P, k) {
    var out = "", i, a;
    for (i = 0; i < P.length; i += 8) {
      a = sc(P[i], k);
      out += '<line class="facet" x1="50" y1="60" x2="' + a[0].toFixed(1) + '" y2="' + a[1].toFixed(1) + '"></line>';
    }
    return out;
  }
  function faceShape(c) {
    if (c.e) return '<ellipse class="face" cx="50" cy="60" rx="' + c.e[0] + '" ry="' + c.e[1] + '"></ellipse>' +
      '<ellipse class="rim" cx="50" cy="60" rx="' + c.e[0] + '" ry="' + c.e[1] + '"></ellipse>';
    if (c.p) return '<polygon class="face" points="' + c.p + '"></polygon>' +
      '<polygon class="rim" points="' + c.p + '"></polygon>';
    return '<path class="face" d="' + c.d + '"></path><path class="rim" d="' + c.d + '"></path>';
  }
  function cutSVG(c) {
    var P = pts(c), f = "";
    if (c.cut === "brilliant") {
      f = ring(P, 0.66) + spokes(P, 0.38, 0.66, 3) + spokes(P, 0.66, 1, 3, 1) +
        spokes(P, 0.66, 1, 3, 2) + ring(P, 0.38);
    } else if (c.cut === "step") {
      f = ring(P, 0.82) + ring(P, 0.60) + ring(P, 0.38) +
        spokes(P, 0.82, 1, 12, 6) + spokes(P, 0.60, 0.82, 12, 6);
    } else if (c.cut === "rose") {
      f = ring(P, 0.52) + star(P, 0.52) + spokes(P, 0.52, 1, 4) + star(P, 0.26);
    } else {                                   /* mixed */
      f = ring(P, 0.72) + ring(P, 0.42) + spokes(P, 0.42, 0.72, 6) + spokes(P, 0.72, 1, 6, 3);
    }
    return '<svg viewBox="0 0 100 120" role="img" aria-label="' + esc(c[lang]) + ' diamond cut">' +
      faceShape(c) + f + "</svg>";
  }

  /* ============================================================
     STONE PHOTOGRAPHY + COLOR TINTING

     Each cut is a real photograph of a colorless stone on black,
     cut out to transparency at build time. Color is applied live
     with an SVG feComponentTransfer curve:

         f(x) = x * ( c + (1-c) * x^4 * H )

     The linear term lays the body color over the stone; the x^4
     term hands the brightest specular highlights back to white,
     which is what keeps a fancy yellow reading as a diamond
     instead of a boiled sweet. H is the highlight-recovery
     strength — 0.86 is the house setting.
     ============================================================ */
  var TINT_H = 0.86, STONES = window.ARA_STONES || [];

  function slugOf(c, i) {
    var n = String(i + 1); if (n.length < 2) n = "0" + n;
    return n + "-" + c.en.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  }
  function photoOf(c, i) {
    var s = slugOf(c, i);
    return STONES.indexOf(s) > -1 ? s : null;
  }
  /* A fancy blue diamond is not a darker white diamond — it is a white
     diamond with two channels pulled down. So the swatch is normalised to
     put its dominant channel back at full: hue without loss of brightness.
     Without this, cool hues (blue, gray, purple) wash out to near-white
     while warm ones read fine.                                            */
  function hx(h) {
    var c = [parseInt(h.substr(1, 2), 16) / 255,
             parseInt(h.substr(3, 2), 16) / 255,
             parseInt(h.substr(5, 2), 16) / 255];
    var m = Math.max(c[0], c[1], c[2]) || 1;
    return [c[0] / m, c[1] / m, c[2] / m];
  }
  function tintCurve(rgb, H) {
    var ch = "RGB", out = "", k, i, x, v;
    for (k = 0; k < 3; k++) {
      v = [];
      for (i = 0; i < 9; i++) {
        x = i / 8;
        v.push((x * (rgb[k] + (1 - rgb[k]) * Math.pow(x, 4) * H)).toFixed(4));
      }
      out += '<feFunc' + ch[k] + ' type="table" tableValues="' + v.join(" ") + '"/>';
    }
    return out;
  }
  /* A 92px tile is mostly midtone, so H = 0.86 leaves plenty of color to see.
     A hero-scale stone is mostly specular, and the same curve whitens it —
     so large stones get a deeper pour with less highlight given back.       */
  var TINT_H_DEEP = 0.42;

  function mountTints() {
    if ($("ara-tints")) return;
    var defs = COLORS.map(function (c) {
      if (c.key === "all") return "";
      var rgb = hx(c.hex);
      return '<filter id="tint-' + c.key + '" color-interpolation-filters="sRGB">' +
             "<feComponentTransfer>" + tintCurve(rgb, TINT_H) + "</feComponentTransfer></filter>" +
             '<filter id="tint-' + c.key + '-deep" color-interpolation-filters="sRGB">' +
             "<feComponentTransfer>" + tintCurve(rgb, TINT_H_DEEP) + "</feComponentTransfer></filter>";
    }).join("");
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("id", "ara-tints");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    svg.innerHTML = "<defs>" + defs + "</defs>";
    document.body.appendChild(svg);
  }

  /* ============================================================
     SECTIONS
     ============================================================ */
  function navLink(k) {
    var n = t().nav;
    return '<a href="' + P(k) + '"' + (k === HERE ? ' aria-current="page"' : "") +
      ">" + n[k] + "</a>";
  }
  function renderNav() {
    if (!$("nav-links")) return;          /* not a section on this page */
    $("nav-links").innerHTML = NAV_MAIN.map(navLink).join("");
    /* the drawer is the whole house — there is room for it on a phone */
    $("drawer").innerHTML = ["home"].concat(NAV_MAIN, NAV_MORE).map(navLink).join("");
  }

  /* The title block that stands where the hero stands on the home page. */
  function renderPageHead() {
    if (!$("page-h1")) return;
    var hd = (t().heads || {})[HERE];
    if (!hd) { $("pagehead").style.display = "none"; return; }
    /* The English title and description are written per page by the
       generator and are the ones search engines should see, so they are
       left alone. Spanish has no per-page pair, so it is built here. */
    if (lang !== "en") {
      document.title = hd.h + " · The Ara Atelier";
      var md = document.querySelector('meta[name="description"]');
      if (md) md.setAttribute("content", hd.lede);
    }
    $("page-h1").innerHTML = words(hd.h);
    $("page-lede").textContent = hd.lede;
    $("crumbs").innerHTML =
      '<a href="' + P("home") + '">' + t().nav.home + "</a>" +
      '<span aria-hidden="true">/</span><span>' + hd.h + "</span>";
    setTimeout(function () { $("pagehead").classList.add("in"); }, 40);
  }

  function renderHero() {
    if (!$("hero-h1")) return;          /* not a section on this page */
    var h = t().hero;
    document.title = t().seo.title;
    var md = document.querySelector('meta[name="description"]');
    if (md) md.setAttribute("content", t().seo.desc);
    $("hero-eyebrow").textContent = h.eyebrow;
    $("hero-h1").innerHTML =
      '<span class="l"><span>' + h.l1 + "</span></span>" +
      '<span class="l"><span class="gold-text"><em>' + h.l2 + "</em></span></span>" +
      '<span class="l"><span>' + h.l3 + "</span></span>";
    $("hero-sub").textContent = h.sub;
    var hm = document.querySelector(".stone-main");
    if (hm && has("hero-kite")) {
      hm.src = S("hero-kite", "gem2.webp");
      hm.removeAttribute("width"); hm.removeAttribute("height");
      hm.alt = h.heroAlt || "Fancy intense pink kite-cut laboratory-grown diamond, IGI certified";
    }
    $("hero-cta1").textContent = h.cta1;
    /* the gold button is the one that makes money: it drops straight to
       the configurator sitting directly below the fold */
    $("hero-cta1").href = $("config") ? "#config" : P("custom") + "#config";
    $("hero-cta2").href = P("book");
    $("hero-cta2").innerHTML = h.cta2 + ' <span class="arw">&#8594;</span>';
    $("badges").innerHTML = t().badges.map(function (b) {
      return '<div class="bdg"><b>' + b.k + "</b><p>" + b.t + "</p><small>" + b.s + "</small></div>";
    }).join("");
    var tick = t().ticker;
    $("ticker").innerHTML = "<span>" + tick.repeat(4) + "</span><span>" + tick.repeat(4) + "</span>";
  }

  /* ---------------- the selection ---------------- */
  function renderSelection() {
    if (!$("selection-in")) return;          /* not a section on this page */
    var s = t().selection;
    $("selection-in").innerHTML = head(s.eyebrow, s.h, s.body) +
      '<div class="filters">' +
      '<div class="frow"><span class="flabel">' + s.fColor + '</span><div class="fset" id="f-color"></div></div>' +
      '<div class="frow"><span class="flabel">' + s.fShape + '</span><div class="fset" id="f-shape"></div></div>' +
      "</div>" +
      '<p class="fcount" id="f-count"></p>' +
      '<div class="cuts" id="cuts"></div>' +
      '<p class="sel-note">' + s.note + "</p>";
    paintFilters(); paintCuts(false);
  }
  function paintFilters() {
    if (!$("f-color")) return;          /* not a section on this page */
    var s = t().selection;
    $("f-color").innerHTML = COLORS.map(function (c) {
      return '<button class="sw" data-c="' + c.key + '" aria-pressed="' + (c.key === color.key) +
        '" style="color:' + c.hex + '"><i style="background:' + c.hex + '"></i><span>' +
        c[lang] + "</span></button>";
    }).join("");
    var shapes = [["all", s.shapeAll], ["round", s.shapeRound], ["oval", s.shapeOval],
                  ["pear", s.shapePear], ["marquise", s.shapeMarquise], ["square", s.shapeSquare],
                  ["geometric", s.shapeGeometric], ["side", s.shapeSide]];
    $("f-shape").innerHTML = shapes.map(function (f) {
      return '<button class="chip" data-fs="' + f[0] + '" aria-pressed="' + (f[0] === fShape) + '">' + f[1] + "</button>";
    }).join("");
  }
  function paintCuts(wave) {
    if (!$("cuts")) return;          /* not a section on this page */
    var s = t().selection;
    var list = CUTS.filter(function (c) {
      return fShape === "all" || c.shape === fShape;
    });
    $("f-count").textContent = list.length + " " + s.count;
    if (!list.length) { $("cuts").innerHTML = '<p class="body-copy" style="grid-column:1/-1">' + s.none + "</p>"; return; }
    var tint = color.key === "all" ? "" : ' style="filter:url(#tint-' + color.key + ')"';
    $("cuts").innerHTML = list.map(function (c) {
      var photo = photoOf(c, c._i), art;
      if (photo) {
        art = '<img class="cutimg" src="' + A("cuts/" + photo + ".webp") + '" width="512" height="512"' +
              ' loading="lazy" decoding="async"' + tint +
              ' alt="' + esc(c[lang]) + " " + esc(s.altStone || "cut laboratory-grown diamond") + '">';
      } else {
        art = cutSVG(c);
      }
      return '<figure class="cut" style="margin:0" title="' + esc(c[lang]) + '">' +
        (c.house ? '<span class="hs" title="' + s.house + '"></span>' : "") +
        art + "<figcaption><b>" + c[lang] + "</b><br><em>" + c.facets + " " + s.facets +
        "</em></figcaption></figure>";
    }).join("");
    if (wave && !reduced) {
      var tiles = $("cuts").children, i;
      for (i = 0; i < tiles.length; i++) (function (el, n) {
        setTimeout(function () {
          el.classList.add("wave");
          setTimeout(function () { el.classList.remove("wave"); }, 820);
        }, n * 24);
      })(tiles[i], i);
    }
  }

  /* ---------------- up close ---------------- */
  function renderUpclose() {
    if (!$("upclose-in")) return;          /* not a section on this page */
    var u = t().upclose;
    var UTINT = (has("upclose-round") && has("upclose-dutch-marquise"))
      ? ' style="filter:url(#tint-blue-deep)"' : "";
    $("upclose-in").innerHTML = head(u.eyebrow, u.h, u.body) +
      '<div class="compare-grid"><div>' +
      '<div class="compare" id="compare">' +
      /* Both frames are shot colorless and tinted by the SAME filter, so the
         hue is identical by construction — the section's whole claim.       */
      '<img src="' + S("upclose-dutch-marquise", "gem2.webp") + '"' + UTINT +
      ' alt="Fancy vivid blue Dutch marquise laboratory-grown diamond">' +
      '<div class="clip" id="clip"><img src="' + S("upclose-round", "gem1.webp") + '"' + UTINT +
      ' alt="Fancy vivid blue round brilliant laboratory-grown diamond"></div>' +
      '<div class="handle" id="handle"><span class="knob">&#8596;</span></div>' +
      '<span class="tagl">' + u.left + '</span><span class="tagr">' + u.right + "</span>" +
      "</div>" +
      '<p class="drag-hint">' + u.drag + "</p>" +
      "</div><div>" +
      '<p class="lede">' + u.lede + "</p>" +
      '<p class="body-copy" style="margin-top:20px">' + u.body + "</p>" +
      "</div></div>";
    wireCompare();
  }
  function wireCompare() {
    var box = $("compare"), clip = $("clip"), handle = $("handle"), on = false;
    function set(x) {
      var r = box.getBoundingClientRect();
      var p = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
      clip.style.clipPath = "inset(0 " + (100 - p) + "% 0 0)";
      handle.style.left = p + "%";
    }
    box.addEventListener("pointerdown", function (e) {
      on = true; try { box.setPointerCapture(e.pointerId); } catch (_) { } set(e.clientX);
    });
    box.addEventListener("pointermove", function (e) { if (on) set(e.clientX); });
    box.addEventListener("pointerup", function () { on = false; });
    box.addEventListener("pointercancel", function () { on = false; });
  }

  function renderStone() {
    if (!$("stone-in")) return;          /* not a section on this page */
    var s = t().stone;
    $("stone-in").innerHTML = head(s.eyebrow, s.h, s.body) +
      '<p class="lede" style="margin:0 0 26px">' + s.lede + "</p>" +
      '<div class="cmp-wrap"><table class="cmp"><caption class="sr">Laboratory-grown versus mined diamonds</caption>' +
      "<thead><tr><th></th><th>" + s.colLab + "</th><th>" + s.colMine + "</th></tr></thead><tbody>" +
      s.rows.map(function (r) {
        return "<tr><td>" + r[0] + '</td><td class="lab">' + r[1] + "</td><td>" + r[2] + "</td></tr>";
      }).join("") + "</tbody></table></div>" +
      '<p class="candor">' + s.candor + "</p>";
  }

  function renderDays() {
    if (!$("days-in")) return;          /* not a section on this page */
    var d = t().days;
    $("days-in").innerHTML = head(d.eyebrow, d.h, d.body) +
      '<div class="days-grid"><div><table class="stage-table">' +
      "<caption>" + d.caption + "</caption>" +
      "<thead><tr><th>" + d.colStage + "</th><th>" + d.colDays + "</th></tr></thead><tbody>" +
      d.stages.map(function (s) { return "<tr><td>" + s[0] + "</td><td>" + s[1] + "</td></tr>"; }).join("") +
      '<tr class="total"><td>' + d.total + "</td><td>" + d.totalV + "</td></tr>" +
      "</tbody></table></div><div>" +
      '<p class="hours-lab">' + d.barTitle + "</p>" +
      '<div class="bar" id="daybar"><div class="g"><span>24.5 d</span></div>' +
      '<div class="c"><span>10 d</span></div><div class="i"><span>15 d</span></div></div>' +
      '<div class="bar-key"><span><i style="background:#8A7440"></i>' + d.keyGrowth +
      '</span><span><i style="background:#AE9459"></i>' + d.keyCutting +
      '</span><span><i style="background:var(--gold-hi)"></i>' + d.keyIgi + "</span></div>" +
      '<div class="hours"><b id="hours-n">0</b><div>' +
      '<p class="hours-lab">' + d.hoursLabel + "</p>" +
      '<p style="margin:0;color:var(--text-2);font-size:16px">' + d.hoursBody + "</p></div></div>" +
      '<p class="pull" style="font-size:clamp(21px,2.4vw,32px)">' + d.pull +
      ' <span class="gold-text">' + d.pull2 + "</span></p>" +
      "</div></div>";
    barWatch();
  }
  function barWatch() {
    var bar = $("daybar"), n = $("hours-n");
    new IntersectionObserver(function (es, ob) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var total = 49.5, d = bar.children;
        d[0].style.flexBasis = (24.5 / total * 100) + "%";
        d[1].style.flexBasis = (10 / total * 100) + "%";
        d[2].style.flexBasis = (15 / total * 100) + "%";
        var v = 0, tick = function () {
          v += 4; if (v >= 146) { n.textContent = "146"; return; }
          n.textContent = v; requestAnimationFrame(tick);
        };
        reduced ? (n.textContent = "146") : tick();
        ob.unobserve(e.target);
      });
    }, { threshold: 0.35 }).observe(bar);
  }

  function renderVocab() {
    if (!$("vocab-in")) return;          /* not a section on this page */
    var v = t().vocab;
    $("vocab-in").innerHTML = head(v.eyebrow, v.h) +
      '<div class="vocab">' + v.items.map(function (i) {
        return '<div class="voc"><span class="c" aria-hidden="true">C</span><h3>' + i.t +
          "</h3><p>" + i.b + "</p></div>";
      }).join("") + "</div>";
  }

  function renderCert() {
    if (!$("cert-in")) return;          /* not a section on this page */
    var c = t().cert;
    $("cert-in").innerHTML = head(c.eyebrow, c.h, c.body) +
      '<dl class="cert-grid">' + c.lines.map(function (l) {
        return '<div class="cl"><dt>' + l[0] + "</dt><dd>" + l[1] + "</dd></div>";
      }).join("") + "</dl>" +
      '<p class="habit">' + c.habit + "</p>";
  }

  function renderRecord() {
    if (!$("record-in")) return;          /* not a section on this page */
    var r = t().record;
    $("record-in").innerHTML = head(r.eyebrow, r.h, r.body) +
      '<div class="rec-grid"><div class="record">' +
      '<div class="rec-head"><h3>' + r.title + "</h3><span>" + r.tag + "</span></div><dl>" +
      r.rows.map(function (x) {
        return '<div class="rr"><dt>' + x[0] + "</dt><dd>" + x[1] + "</dd></div>";
      }).join("") + '</dl></div><div><p class="rec-note">' + r.note + "</p>" +
      '<img src="' + A("gem3.webp") + '" alt="Fancy intense pink kite-cut laboratory-grown diamond" ' +
      'style="width:58%;margin:26px auto 0;filter:drop-shadow(0 20px 40px rgba(0,0,0,.6))"></div></div>';
  }

  /* ---------------- the ring ---------------- */
  var RING =
    '<svg viewBox="0 0 400 470" role="img" aria-label="Solitaire ring in solid gold with a round brilliant center stone">' +
    '<defs>' +
    '<linearGradient id="g-gold" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0%" stop-color="#6E5623"/><stop offset="24%" stop-color="#E6D3A3"/>' +
    '<stop offset="52%" stop-color="#C2A25F"/><stop offset="78%" stop-color="#8A6F31"/>' +
    '<stop offset="100%" stop-color="#E6D3A3"/></linearGradient>' +
    '<radialGradient id="g-stone" cx="42%" cy="34%">' +
    '<stop offset="0%" stop-color="#FFFFFF"/><stop offset="46%" stop-color="#E8EEF4"/>' +
    '<stop offset="100%" stop-color="#9FAEBC"/></radialGradient>' +
    '<radialGradient id="g-flare">' +
    '<stop offset="0%" stop-color="#F4F1EA" stop-opacity=".55"/>' +
    '<stop offset="60%" stop-color="#C2A25F" stop-opacity=".16"/>' +
    '<stop offset="100%" stop-color="#C2A25F" stop-opacity="0"/></radialGradient>' +
    '</defs>' +
    '<circle class="ring-glow" cx="200" cy="150" r="120" fill="url(#g-flare)"/>' +
    /* shank */
    '<ellipse cx="200" cy="318" rx="104" ry="118" fill="none" stroke="url(#g-gold)" stroke-width="17"/>' +
    '<ellipse cx="200" cy="318" rx="104" ry="118" fill="none" stroke="#000" stroke-width="1" opacity=".35"/>' +
    /* gallery / basket under the head */
    '<path d="M168 214 L200 236 L232 214" fill="none" stroke="url(#g-gold)" stroke-width="7" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M176 204 H224" stroke="url(#g-gold)" stroke-width="6" stroke-linecap="round"/>' +
    /* stone: round brilliant, drawn facet by facet */
    '<g>' +
    '<circle cx="200" cy="152" r="60" fill="url(#g-stone)" stroke="#F4F1EA" stroke-width="1.4"/>' +
    '<polygon points="200,112 228,124 240,152 228,180 200,192 172,180 160,152 172,124" fill="#FFFFFF" opacity=".34"/>' +
    '<polygon points="200,112 228,124 240,152 228,180 200,192 172,180 160,152 172,124" fill="none" stroke="#F4F1EA" stroke-width="1"/>' +
    '<g stroke="#F4F1EA" stroke-width=".9" opacity=".8">' +
    '<line x1="200" y1="112" x2="200" y2="92"/><line x1="228" y1="124" x2="242" y2="110"/>' +
    '<line x1="240" y1="152" x2="260" y2="152"/><line x1="228" y1="180" x2="242" y2="194"/>' +
    '<line x1="200" y1="192" x2="200" y2="212"/><line x1="172" y1="180" x2="158" y2="194"/>' +
    '<line x1="160" y1="152" x2="140" y2="152"/><line x1="172" y1="124" x2="158" y2="110"/>' +
    '</g>' +
    '<g stroke="#F4F1EA" stroke-width=".7" opacity=".5">' +
    '<line x1="214" y1="116" x2="221" y2="97"/><line x1="236" y1="138" x2="254" y2="130"/>' +
    '<line x1="236" y1="166" x2="254" y2="174"/><line x1="214" y1="188" x2="221" y2="207"/>' +
    '<line x1="186" y1="188" x2="179" y2="207"/><line x1="164" y1="166" x2="146" y2="174"/>' +
    '<line x1="164" y1="138" x2="146" y2="130"/><line x1="186" y1="116" x2="179" y2="97"/>' +
    '</g>' +
    '<polygon points="200,112 214,132 200,152 186,132" fill="#FFFFFF" opacity=".5"/>' +
    "</g>" +
    /* prongs over the girdle */
    '<g fill="url(#g-gold)">' +
    '<path d="M158 118 q10 -14 22 -6 q-6 12 -4 22 z"/>' +
    '<path d="M242 118 q-10 -14 -22 -6 q6 12 4 22 z"/>' +
    '<path d="M158 186 q10 14 22 6 q-6 -12 -4 -22 z"/>' +
    '<path d="M242 186 q-10 14 -22 6 q6 -12 4 -22 z"/>' +
    "</g>" +
    /* sparkle */
    '<g class="ring-glow" fill="#F4F1EA">' +
    '<path d="M286 86 L290 104 L308 108 L290 112 L286 130 L282 112 L264 108 L282 104 Z"/>' +
    '<path d="M118 196 L121 208 L133 211 L121 214 L118 226 L115 214 L103 211 L115 208 Z" opacity=".7"/>' +
    "</g></svg>";

  function renderBespoke() {
    if (!$("bespoke-in")) return;          /* not a section on this page */
    var b = t().bespoke;
    $("bespoke-in").innerHTML =
      '<div class="bespoke-grid"><div class="ring-stage">' +
      (has("ring")
        ? '<img class="ring-photo wipe" src="' + S("ring", "") + '" loading="lazy" decoding="async"' +
          ' alt="Made-to-order yellow gold ring set with a fancy vivid yellow laboratory-grown cushion diamond and tapered baguette side stones">'
        : RING) + "</div><div>" +
      '<p class="eyebrow">' + b.eyebrow + '</p><h2 class="display" style="font-size:var(--f-h2)">' +
      words(b.h) + "</h2>" +
      '<p class="body-copy" style="margin-top:22px">' + b.body + "</p>" +
      '<div class="offers">' + b.offers.map(function (o) {
        return '<div class="offer"><h3>' + o[0] + "</h3><p>" + o[1] + "</p></div>";
      }).join("") + "</div></div></div>" +
      '<div class="steps"><div class="steps-head"><h3>' + b.chainTitle + "</h3><span>" + b.chainHint + "</span></div>" +
      '<div class="step-row" id="step-row"></div>' +
      '<div class="step-body" id="step-body"></div></div>';
    paintSteps();
  }
  var STEP_KEYS = ["step-1-talk", "step-2-sketch", "step-3-cad",
                   "step-4-wax", "step-5-bench", "step-6-check"];
  function paintSteps() {
    var b = t().bespoke, R = ["I", "II", "III", "IV", "V", "VI"];
    $("step-row").innerHTML = b.chain.map(function (s, i) {
      return '<button data-step="' + i + '" aria-pressed="' + (i === step) + '"><b>' + R[i] + "</b>" + s.t + "</button>";
    }).join("");
    var key = STEP_KEYS[step];
    var shot = has(key)
      ? '<figure class="step-shot"><img src="' + S(key, "") + '" loading="lazy" decoding="async" alt="' +
        esc(b.chain[step].t) + ' — the ' + esc(b.chain[step].t.toLowerCase()) +
        ' stage of a made-to-order Ara Atelier commission"></figure>'
      : "";
    $("step-body").innerHTML = shot +
      "<div><h4>" + R[step] + " &nbsp;·&nbsp; " + b.chain[step].t + "</h4><p>" + b.chain[step].b + "</p></div>";
    $("step-body").classList.toggle("has-shot", !!shot);
  }

  /* ---------------- commission form ---------------- */
  function renderCommission() {
    if (!$("commission-in")) return;          /* not a section on this page */
    var f = t().commission;
    /* the confirmation modal is always in the DOM — fill it at render so it
       never sits there as an empty heading for a crawler to find */
    $("ok-title").textContent = f.okTitle;
    $("ok-body").textContent = f.okBody;
    $("ok-close").textContent = f.close;
    $("commission-in").innerHTML = head(f.eyebrow, f.h, f.body) +
      '<form id="cform" novalidate>' +
      '<div class="form-grid">' +
      fld("name", f.fName, '<input id="c-name" name="name" type="text" autocomplete="name" required>') +
      fld("email", f.fEmail, '<input id="c-email" name="email" type="email" autocomplete="email" inputmode="email" required>') +
      fld("phone", f.fPhone, '<input id="c-phone" name="phone" type="tel" autocomplete="tel" inputmode="tel">') +
      fld("tiktok", f.fTikTok, '<input id="c-tiktok" name="tiktok" type="text" placeholder="@">', f.fTikTokHint) +
      fld("stone", f.fStone, '<input id="c-stone" name="stone" type="text">', f.fStoneHint, true) +
      fld("piece", f.fPiece, '<select id="c-piece" name="piece" required>' +
        f.fPieceOpts.map(function (o) { return '<option value="' + esc(o) + '">' + o + "</option>"; }).join("") +
        "</select>") +
      fld("file", f.fFile,
        '<div class="filewrap"><label class="filebtn" for="c-file">&#43; ' + f.fFile +
        '</label><input id="c-file" name="attachment" type="file" accept="image/*,.pdf" class="sr">' +
        '<span class="filename" id="c-filename"></span></div>', f.fFileHint) +
      fld("details", f.fDetails, '<textarea id="c-details" name="details" rows="4"></textarea>', f.fDetailsHint, true) +
      "</div>" +
      /* Invisible to a person, irresistible to a bot. Anything typed here
         means the submission is not human, and the server drops it. */
      '<div aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden">' +
      '<label for="c-company">Company</label>' +
      '<input id="c-company" name="company" type="text" tabindex="-1" autocomplete="off"></div>' +
      '<div class="form-foot"><button class="btn btn-gold" type="submit" id="c-submit">' + f.submit +
      '</button><span class="form-msg" id="c-msg"></span></div>' +
      '<p class="quoted">' + f.quoted + "</p>" +
      "</form>";
    wireForm();
  }
  function fld(id, label, control, hint, full) {
    var lab = /(^|-)file$/.test(id)
      ? '<span class="flabel" style="padding:0;color:var(--gold)">' + label + "</span>"
      : '<label for="c-' + id + '">' + label + "</label>";
    return '<div class="field' + (full || /(^|-)(file|details)$/.test(id) ? " full" : "") + '" data-f="' + id + '">' +
      lab + control +
      (hint ? '<span class="hint">' + hint + "</span>" : "") + "</div>";
  }
  function wireForm() {
    var form = $("cform"), file = $("c-file"), f = t().commission;
    file.addEventListener("change", function () {
      $("c-filename").textContent = file.files && file.files[0] ? f.fFileChosen + ": " + file.files[0].name : "";
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      submitForm();
    });
  }
  function submitForm() {
    var f = t().commission, msg = $("c-msg"), btn = $("c-submit");
    var v = {
      name: $("c-name").value.trim(), email: $("c-email").value.trim(),
      phone: $("c-phone").value.trim(), tiktok: $("c-tiktok").value.trim(),
      stone: $("c-stone").value.trim(), piece: $("c-piece").value,
      details: $("c-details").value.trim()
    };
    var bad = [];
    if (!v.name) bad.push("name");
    if (!v.email || v.email.indexOf("@") < 1) bad.push("email");
    if (!v.piece) bad.push("piece");
    document.querySelectorAll("#cform .field").forEach(function (el) {
      el.classList.toggle("err", bad.indexOf(el.dataset.f) > -1);
    });
    if (bad.length) { msg.textContent = f.required; return; }
    msg.textContent = "";

    var file = $("c-file").files && $("c-file").files[0];
    if (!ARA_API) { mailFallback(v, f); return; }

    btn.textContent = f.sending; btn.disabled = true;
    v.lang = lang;
    v.page = location.href;
    v.company = $("c-company") ? $("c-company").value : "";   /* honeypot */

    readAttachment(file)
      .then(function (att) {
        if (att) v.attachment = att;
        return fetch(ARA_API + "/inquiry", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(v)
        });
      })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || !j.ok) throw new Error(j.error || r.status);
          return j;
        });
      })
      .then(function () {
        showOk(f.okNote);
        $("cform").reset();
        $("c-filename").textContent = "";
      })
      .catch(function (err) {
        /* Never lose an inquiry to a network blip — hand it to their mail app */
        msg.textContent = (err && /too large/i.test(err.message)) ? err.message : "";
        mailFallback(v, f);
      })
      .then(function () { btn.textContent = f.submit; btn.disabled = false; });
  }

  /* the picture rides along as base64 inside the JSON body */
  function readAttachment(file) {
    return new Promise(function (resolve) {
      if (!file) return resolve(null);
      if (file.size > 8 * 1024 * 1024) return resolve(null);
      var fr = new FileReader();
      fr.onload = function () {
        var s = String(fr.result);
        resolve({ filename: file.name, data: s.slice(s.indexOf(",") + 1) });
      };
      fr.onerror = function () { resolve(null); };
      fr.readAsDataURL(file);
    });
  }
  function mailFallback(v, f) {
    var L = t().commission;
    var body =
      L.fName + ": " + v.name + "\n" +
      L.fEmail + ": " + v.email + "\n" +
      L.fPhone + ": " + (v.phone || "—") + "\n" +
      L.fTikTok + ": " + (v.tiktok || "—") + "\n" +
      L.fStone + ": " + (v.stone || "—") + "\n" +
      L.fPiece + ": " + v.piece + "\n\n" +
      L.fDetails + ":\n" + (v.details || "—") + "\n\n" +
      "— " + location.href;
    var a = document.createElement("a");
    a.href = "mailto:" + INBOX + "?subject=" + encodeURIComponent(SUBJECT) + "&body=" + encodeURIComponent(body);
    a.style.display = "none"; document.body.appendChild(a); a.click(); a.remove();
    showOk(f.mailNote);
  }
  function showOk(note) {
    var f = t().commission;
    $("ok-title").textContent = f.okTitle;
    $("ok-body").textContent = f.okBody;
    $("ok-note").textContent = note || "";
    $("ok-close").textContent = f.close;
    $("ok-modal").classList.add("open"); $("ok-scrim").classList.add("open");
    $("ok-close").focus();
  }
  function closeOk() { $("ok-modal").classList.remove("open"); $("ok-scrim").classList.remove("open"); }

  /* ============================================================
     THE CAMPAIGN — finished pieces, worn

     Photographs, not cutouts: they keep their own black ground and
     sit in the page as frames rather than floating objects.
     ============================================================ */
  var CAMPAIGN = window.ARA_CAMPAIGN || [];
  function hasShot(n) { return CAMPAIGN.indexOf(n) > -1; }
  function shot(n) { return A("campaign/" + n + ".webp"); }

  /* the lookbook, in the order it reads best — a rhythm of close and
     closer rather than all the rings together, then all the earrings */
  var WORN = [
    "ring-01-yellow-cushion", "earring-02-yellow-stud", "pendant-01-blue-kite",
    "model-01-necklace",      "ring-02-pink-pear",      "earring-01-marquise-drop",
    "pendant-03-solitaire",   "ring-03-blue-kite-trio", "earring-03-pear-drop",
    "model-02-strapless",     "bracelet-01-line",       "pendant-02-green-emerald",
    "ring-04-yellow-on-stone","earring-04-pink-pear",   "ring-05-backlit"
  ];

  /* a frame reveals one of two ways: driven by its section (the band, three
     at a time) or on its own approach (the lookbook, marked "rev"). Giving
     it both would open it twice. */
  function frame(name, alt, cls) {
    if (!hasShot(name)) return "";
    cls = cls || "";
    return '<figure class="shot ' + cls + '">' +
      '<img class="' + (cls.indexOf("rev") > -1 ? "" : "wipe") + '" src="' + shot(name) +
      '" loading="lazy" decoding="async" alt="' + esc(alt) + '"></figure>';
  }

  /* the band on the home page — three frames and a sentence */
  function renderWornBand() {
    var w = t().wornband, el = $("wornband-in");
    if (!el) return;
    /* three portraits of the same proportion — a triptych hangs straight.
       The landscape ring frame is saved for the lookbook, where the
       column flow can take it at its own height. */
    var three = ["ring-02-pink-pear", "earring-02-yellow-stud", "pendant-01-blue-kite"];
    if (!three.some(hasShot)) { el.parentNode.style.display = "none"; return; }
    el.innerHTML =
      '<div class="band-head"><div><p class="eyebrow">' + w.eyebrow + '</p>' +
      '<h2 class="display">' + words(w.h) + "</h2></div>" +
      '<div><p class="body-copy">' + w.body + "</p>" +
      '<a class="btn btn-ghost" href="' + P("worn") + '">' + w.cta + ' <span class="arw">&#8594;</span></a></div></div>' +
      '<div class="band">' + three.map(function (n, i) {
        return frame(n, t().worn.eyebrow + " — " + ["ring", "earring", "pendant"][i], "b" + i);
      }).join("") + "</div>";
  }

  /* the lookbook */
  function renderWorn() {
    var w = t().worn, el = $("worn-in");
    if (!el) return;
    var have = WORN.filter(hasShot);
    if (!have.length) { el.parentNode.style.display = "none"; return; }
    /* each frame reveals on its own approach — fifteen images opening at
       once when the section head crosses would spend the whole effect
       above the fold and leave the scroll silent */
    el.innerHTML = head(w.eyebrow, w.h, w.body) +
      '<div class="lookbook">' + have.map(function (n, i) {
        return frame(n, w.eyebrow + " " + (i + 1), "rev");
      }).join("") + "</div>" +
      '<div class="worn-foot"><p class="sel-note">' + w.note + "</p>" +
      '<a class="btn btn-gold" href="' + P("custom") + '#commission">' + w.cta + "</a></div>";
  }

  /* the doorways */
  function renderPages() {
    var p = t().pages, el = $("pages-in");
    if (!el) return;
    el.innerHTML = head(p.eyebrow, p.h) +
      '<div class="callouts">' + p.items.map(function (it) {
        return '<a class="callout" href="' + P(it.k === "order" ? "custom" : it.k) + '" data-k="' + it.k + '">' +
          '<span class="callout-img">' +
          (hasShot(it.img)
            ? '<img src="' + shot(it.img) + '" loading="lazy" decoding="async" alt="' + esc(it.t) + '">'
            : "") +
          "</span>" +
          '<span class="callout-body">' +
          '<span class="callout-kicker">' + it.s + "</span>" +
          "<h3>" + it.t + "</h3>" +
          "<p>" + it.b + "</p>" +
          '<span class="callout-go"><i></i><span class="arw">&#8594;</span></span>' +
          "</span></a>";
      }).join("") + "</div>";
  }

  var TT = "https://www.tiktok.com/@" + TIKTOK;
  function ttBtn(label, sub, ghost) {
    return '<a class="btn ' + (ghost ? "btn-ghost" : "btn-gold") + ' tt-btn" href="' + TT +
      '" target="_blank" rel="noopener">' + label +
      (sub ? ' <span class="tt-at">' + sub + "</span>" : "") + "</a>";
  }

  function renderLive() {
    if (!$("live-in")) return;          /* not a section on this page */
    var l = t().live;
    $("live-in").innerHTML = head(l.eyebrow, l.h, l.body) +
      '<div class="soon-card live-card"><span class="soon-badge on"><i></i>' + l.soon + "</span>" +
      "<h3>" + l.soonBody + "</h3>" +
      '<div class="soon-cta">' + ttBtn(l.cta, l.ctaSub) + "</div></div>";
  }

  function renderVault() {
    if (!$("vault-in")) return;          /* not a section on this page */
    var v = t().vault;
    $("vault-in").innerHTML = head(v.eyebrow, v.h) +
      '<div class="soon-card live-card"><span class="soon-badge on"><i></i>' + v.soon + "</span>" +
      "<p>" + v.body + "</p>" +
      '<div class="soon-cta">' + ttBtn(v.cta, v.ctaSub) +
      '<a class="btn btn-ghost" href="' + P("custom") + '#commission">' + v.alt + "</a></div></div>";
  }

  function renderEthics() {
    if (!$("ethics-in")) return;          /* not a section on this page */
    var e = t().ethics;
    $("ethics-in").innerHTML = head(e.eyebrow, e.h, e.body) +
      '<div class="ethics">' + e.items.map(function (i) {
        return '<div class="eth"><h3>' + i[0] + "</h3><p>" + i[1] + "</p></div>";
      }).join("") + "</div>" +
      '<p class="claim">' + e.claim + "</p>";
  }

  /* ---------------- FAQ (and its schema) ---------------- */
  function renderFaq() {
    if (!$("faq-in")) return;          /* not a section on this page */
    var f = t().faq;
    $("faq-in").innerHTML = head(f.eyebrow, f.h) +
      '<div class="faq">' + f.items.map(function (q, i) {
        return '<div class="qa"><button type="button" aria-expanded="false" aria-controls="ans-' + i + '">' +
          "<span>" + q[0] + '</span><span class="pm" aria-hidden="true"></span></button>' +
          '<div class="ans" id="ans-' + i + '"><p>' + q[1] + "</p></div></div>";
      }).join("") + "</div>";

    var qas = $("faq-in").querySelectorAll(".qa");
    qas.forEach(function (qa) {
      var btn = qa.querySelector("button"), ans = qa.querySelector(".ans");
      btn.addEventListener("click", function () {
        var open = qa.classList.contains("open");
        qas.forEach(function (o) {
          if (o !== qa && o.classList.contains("open")) {
            o.classList.remove("open");
            o.querySelector(".ans").style.maxHeight = "0px";
            o.querySelector("button").setAttribute("aria-expanded", "false");
          }
        });
        qa.classList.toggle("open", !open);
        btn.setAttribute("aria-expanded", String(!open));
        ans.style.maxHeight = open ? "0px" : ans.scrollHeight + 8 + "px";
      });
    });

    $("faq-schema").textContent = JSON.stringify({
      "@context": "https://schema.org", "@type": "FAQPage",
      mainEntity: f.items.map(function (q) {
        return { "@type": "Question", name: q[0],
          acceptedAnswer: { "@type": "Answer", text: q[1] } };
      })
    });
  }

  function renderContact() {
    if (!$("contact-in")) return;          /* not a section on this page */
    var c = t().contact;
    $("contact-in").innerHTML = head(c.eyebrow, c.h) +
      '<dl class="contact-grid">' +
      '<div class="cc"><dt>' + c.email + '</dt><dd><a href="mailto:' + INBOX + '">' + INBOX + "</a></dd></div>" +
      '<div class="cc"><dt>' + c.tiktok + '</dt><dd><a href="https://www.tiktok.com/@' + TIKTOK +
      '" target="_blank" rel="noopener">@' + TIKTOK + "</a></dd></div>" +
      '<div class="cc"><dt>' + c.hours + "</dt><dd>" + c.hoursV + "</dd></div>" +
      '<div class="cc"><dt>' + c.replies + "</dt><dd>" + c.repliesV + "</dd></div>" +
      "</dl>";
  }

  function renderFooter() {
    if (!$("footer-in")) return;          /* not a section on this page */
    var c = t().contact, l = t().legal, f = t().footer, q = lang === "es" ? "?lang=es" : "";
    var U = window.ARA_LEGAL_URLS ||
      { terms: "terms.html", privacy: "privacy.html", shipping: "shipping.html" };
    $("footer-in").innerHTML =
      '<div class="foot-grid"><div>' +
      '<img class="foot-logo" src="' + A("logo-white.png") + '" alt="The Ara Atelier" width="104" height="84">' +
      '<p class="display" style="font-size:clamp(28px,3.6vw,50px);margin:0">The Ara Atelier</p>' +
      '<p class="hours-lab" style="margin:14px 0 0">' + c.cityLine.split("·").slice(1).join("·").trim() +
      " &nbsp;·&nbsp; " + c.hoursV + "</p>" +
      '<nav class="legal-links" aria-label="Legal">' +
      '<a href="' + U.terms + q + '">' + l.terms + "</a>" +
      '<a href="' + U.privacy + q + '">' + l.privacy + "</a>" +
      '<a href="' + U.shipping + q + '">' + l.shipping + "</a>" +
      "</nav></div><div>" +
      /* every page reachable from every page — for a reader on a phone,
         and for a crawler that will not run our JavaScript twice */
      '<nav class="foot-map" aria-label="' + t().nav.home + '">' +
      ["home"].concat(NAV_MAIN, NAV_MORE).map(function (k) {
        return '<a href="' + P(k) + '">' + t().nav[k] + "</a>";
      }).join("") + "</nav>" +
      '<p class="body-copy" style="margin:0">' + c.blurb + "</p></div></div>" +
      '<p class="disclaimer">' + l.disclaimer + "</p>" +
      '<div class="colophon"><span>&copy; ' + new Date().getFullYear() +
      " The Ara Atelier &nbsp;·&nbsp; " + f.rights + "</span><span>" + f.line + "</span></div>";
  }


  /* ============================================================
     THE CONFIGURATOR — the price of a setting, one question at a time

     The questions a customer is asked depend on what they are making:
     a chain takes no stone, earrings take a back. So the steps are not
     a fixed list of three — they are built from ARA_PIECES each time
     the piece changes.

     Every number comes from prices.js, generated from Prince's
     workbook. Nothing about price is typed in this file, and the Worker
     recomputes the figure from its own copy of the same table before it
     will take a payment — what the browser says a setting costs is a
     display, never an instruction.
     ============================================================ */
  var PRICES = window.ARA_PRICES || null;
  var TREE = window.ARA_PIECES || [];
  var cfg = { metal: null, piece: null, style: null, band: null, back: null };

  function byKey(list, k) {
    for (var i = 0; i < list.length; i++) if (list[i].k === k) return list[i];
    return null;
  }
  function idx(list, k) {
    for (var i = 0; i < list.length; i++) if (list[i].k === k) return i;
    return -1;
  }
  var pieceOf  = function () { return cfg.piece ? byKey(TREE, cfg.piece) : null; };
  var styleOf  = function () { var p = pieceOf(); return p && cfg.style ? byKey(p.styles, cfg.style) : null; };

  /* the questions this piece actually needs, in order */
  function steps() {
    var p = pieceOf(), out = [
      { k: "metal", q: 1, done: !!cfg.metal },
      { k: "piece", q: 2, done: !!cfg.piece },
      { k: "style", q: 3, done: !!cfg.style }
    ];
    if (!p || !p.noStone) out.push({ k: "band", q: 4, done: !!cfg.band });
    if (p && p.backs)     out.push({ k: "back", q: 5, done: !!cfg.back });
    return out;
  }
  function complete() {
    var st = steps(), i;
    for (i = 0; i < st.length; i++) if (!st[i].done) return false;
    return true;
  }

  /* one column lookup, plus the surcharge for a style the chart has no
     column of its own for */
  function cell(metalKey, col, bandKey) {
    if (!PRICES) return null;
    var m = byKey(PRICES.metals, metalKey || "14k");
    var ci = idx(PRICES.pieces, col), bi = idx(PRICES.bands, bandKey);
    if (!m || ci < 0 || bi < 0) return null;
    var row = (PRICES.table[m.table] || [])[bi];
    return row && row[ci] != null ? row[ci] : null;
  }
  function priceOf() {
    if (!complete()) return null;
    var st = styleOf();
    if (!st) return null;
    var band = st.band || cfg.band;             /* a chain is pinned to one row */
    var v = cell(cfg.metal, st.col, band);
    return v == null ? null : v + (st.add || 0);
  }
  /* the cheapest this piece ever gets in the chosen metal — the "from" */
  function fromOf(metalKey, pieceKey) {
    var p = byKey(TREE, pieceKey);
    if (!p || !PRICES) return null;
    var lo = null;
    p.styles.forEach(function (st) {
      var bands = st.band ? [st.band] : PRICES.bands.map(function (b) { return b.k; });
      bands.forEach(function (bk) {
        var v = cell(metalKey, st.col, bk);
        if (v != null) { v += (st.add || 0); if (lo === null || v < lo) lo = v; }
      });
    });
    return lo;
  }
  function money(n) {
    return "$" + Number(n).toLocaleString("en-US", { maximumFractionDigits: 2 });
  }

  function opt(attr, key, label, sub, on) {
    return '<button type="button" class="cfg-opt" data-' + attr + '="' + key +
      '" aria-pressed="' + !!on + '"><span>' + label + "</span>" +
      (sub ? "<em>" + sub + "</em>" : "") + "</button>";
  }

  function cfgOpts() {
    if (!PRICES || !$("cfg-metal")) return;
    var c = t().config, p = pieceOf();

    $("cfg-metal").innerHTML = PRICES.metals.map(function (m) {
      return '<button type="button" class="cfg-opt metal" data-cm="' + m.k +
        '" aria-pressed="' + (cfg.metal === m.k) + '">' +
        '<i class="mdot m-' + m.k + '" aria-hidden="true"></i>' +
        "<span>" + m[lang] + "</span></button>";
    }).join("");

    $("cfg-piece").innerHTML = TREE.map(function (pc) {
      var lo = fromOf(cfg.metal, pc.k);
      return opt("cp", pc.k, pc[lang],
        lo ? c.from + " " + money(lo) : pc["hint_" + lang], cfg.piece === pc.k);
    }).join("");

    $("cfg-style").innerHTML = !p ? "" : p.styles.map(function (st) {
      return opt("cs", st.k, st[lang], null, cfg.style === st.k);
    }).join("");

    $("cfg-band").innerHTML = PRICES.bands.map(function (b) {
      return '<button type="button" class="cfg-opt chip" data-cb="' + b.k +
        '" aria-pressed="' + (cfg.band === b.k) + '">' + b[lang] + "</button>";
    }).join("");

    $("cfg-back").innerHTML = !(p && p.backs) ? "" : p.backs.map(function (bk) {
      return opt("ck", bk.k, bk[lang], null, cfg.back === bk.k);
    }).join("");

    cfgLocks();
    cfgPlate();
  }

  /* a question opens only once the one above it is answered, and a
     question this piece does not need is not shown at all */
  function cfgLocks() {
    var st = steps(), live = {}, i, open = true;
    for (i = 0; i < st.length; i++) {
      live[st[i].q] = open;
      if (!st[i].done) open = false;            /* nothing past the first gap */
    }
    [1, 2, 3, 4, 5].forEach(function (n) {
      var el = document.querySelector('.cfg-step[data-s="' + n + '"]');
      if (!el) return;
      var used = live[n] !== undefined;
      el.hidden = !used;
      el.classList.toggle("open", !!live[n]);
      el.querySelectorAll(".cfg-opt").forEach(function (b) {
        b.setAttribute("aria-disabled", String(!live[n]));
        b.tabIndex = live[n] ? 0 : -1;
      });
    });
    var done = 0;
    for (i = 0; i < st.length; i++) if (st[i].done) done++;
    if ($("cfg-done")) $("cfg-done").textContent = done + " " + t().config.of + " " + st.length;
  }

  var cfgAnim = null;
  function cfgPlate() {
    var c = t().config, p = priceOf(), pc = pieceOf(), st = styleOf(), plate = $("cfg-plate");
    if (!plate) return;
    plate.classList.toggle("ready", p != null);
    var sum = [];
    if (cfg.metal) sum.push(byKey(PRICES.metals, cfg.metal)[lang]);
    if (pc) sum.push(pc[lang]);
    if (st && !(pc && pc.styles.length === 1)) sum.push(st[lang]);
    if (cfg.band && pc && !pc.noStone) sum.push(byKey(PRICES.bands, cfg.band)[lang]);
    if (cfg.back && pc && pc.backs) sum.push(byKey(pc.backs, cfg.back)[lang]);
    $("cfg-sum").innerHTML = sum.map(function (x) { return "<li>" + x + "</li>"; }).join("");
    $("cfg-hint").textContent = p == null ? c.pick : "";
    /* a chain has no stone in it at all, so it gets its own notice */
    var chain = pc && pc.noStone;
    $("cfg-nostone").innerHTML = "<b>" + (chain ? c.noChain : c.noStone) + "</b> " +
      (chain ? c.noChainB : c.noStoneB);
    countTo(p);
  }
  /* the number arrives rather than appearing */
  function countTo(p) {
    var el = $("cfg-amount");
    if (!el) return;
    if (cfgAnim) { cancelAnimationFrame(cfgAnim); cfgAnim = null; }
    if (p == null) { el.textContent = "—"; return; }
    if (reduced) { el.textContent = money(p); return; }
    var from = 0, t0 = performance.now(), dur = 760;
    (function tick(now) {
      var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = money(Math.round((from + (p - from) * e) / 5) * 5);
      if (k < 1) cfgAnim = requestAnimationFrame(tick);
      else { el.textContent = money(p); cfgAnim = null; }
    })(t0);
    el.classList.remove("flash"); void el.offsetWidth; el.classList.add("flash");
  }

  function renderConfig() {
    if (!$("config-in")) return;
    var c = t().config;
    if (!PRICES || !TREE.length) { $("config-in").parentNode.style.display = "none"; return; }
    var q = [[1, c.q1, c.q1b, "cfg-metal"], [2, c.q2, c.q2b, "cfg-piece"],
             [3, c.q3, c.q3b, "cfg-style"], [4, c.q4, c.q4b, "cfg-band"],
             [5, c.q5, c.q5b, "cfg-back"]];
    $("config-in").innerHTML = head(c.eyebrow, c.h, c.body) +
      '<div class="cfg">' +
      '<ol class="cfg-steps">' + q.map(function (sq) {
        return '<li class="cfg-step' + (sq[0] === 1 ? " open" : "") + '" data-s="' + sq[0] + '"' +
          (sq[0] > 3 ? " hidden" : "") + ">" +
          '<div class="cfg-q"><span class="cfg-n">' + sq[0] + "</span>" +
          "<div><h3>" + sq[1] + "</h3><p>" + sq[2] + "</p></div></div>" +
          '<div class="cfg-opts" id="' + sq[3] + '"></div></li>';
      }).join("") + "</ol>" +
      '<aside class="cfg-plate" id="cfg-plate">' +
      '<div class="cfg-plate-in">' +
      '<span class="cfg-k">' + c.totalT + '<b id="cfg-done">0 ' + c.of + " 3</b></span>" +
      '<div class="cfg-amount" id="cfg-amount">—</div>' +
      '<ul class="cfg-sum" id="cfg-sum"></ul>' +
      '<p class="cfg-hint" id="cfg-hint"></p>' +
      '<p class="cfg-nostone" id="cfg-nostone"></p>' +
      '<ul class="cfg-inc">' + c.included.map(function (i) {
        return "<li>" + i + "</li>"; }).join("") + "</ul>" +
      '<button class="btn btn-gold cfg-go" id="cfg-go">' + c.cta + "</button>" +
      '<small class="cfg-made">' + c.madeIn + "</small>" +
      '<button type="button" class="cfg-reset" id="cfg-reset">' + c.reset + "</button>" +
      "</div></aside></div>";
    cfgOpts();
  }

  function cfgSpec() {
    var pc = pieceOf(), st = styleOf(), p = priceOf();
    var bits = [pc.en];
    if (pc.styles.length > 1) bits.push(st.en.toLowerCase());
    return {
      metal: cfg.metal, piece: cfg.piece, style: cfg.style,
      band: pc.noStone ? null : cfg.band, back: cfg.back,
      metalLabel: byKey(PRICES.metals, cfg.metal).en,
      pieceLabel: bits.join(", "),
      bandLabel: pc.noStone ? null : byKey(PRICES.bands, cfg.band).en,
      backLabel: cfg.back && pc.backs ? byKey(pc.backs, cfg.back).en : null,
      shown: p, lang: lang, page: location.href
    };
  }
  function mailQuote(spec, c) {
    location.href = "mailto:" + INBOX + "?subject=" + encodeURIComponent(SUBJECT) +
      "&body=" + encodeURIComponent(
        [spec.metalLabel, spec.pieceLabel, spec.bandLabel, spec.backLabel]
          .filter(Boolean).join(" · ") +
        "\n" + c.totalT + ": " + money(spec.shown) + "\n" + c.noStone + "\n\n");
  }
  function cfgCheckout() {
    var c = t().config, btn = $("cfg-go");
    if (!complete()) { $("cfg-hint").textContent = c.errPick; return; }
    var spec = cfgSpec();
    if (spec.shown == null) { $("cfg-hint").textContent = c.errPick; return; }
    if (!ARA_API) { mailQuote(spec, c); return; }

    btn.disabled = true; btn.textContent = c.busy;
    fetch(ARA_API + "/checkout", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify(spec)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || !j.ok) throw new Error(j.error || r.status);
        return j;
      });
    }).then(function (j) {
      if (j.url) { location.href = j.url; return; }
      /* no Shopify token yet — the spec is emailed and the house replies */
      showOkCustom(c.quoteOk, c.quoteBody, "");
      btn.disabled = false; btn.textContent = c.cta;
    }).catch(function () {
      $("cfg-hint").textContent = "";
      btn.disabled = false; btn.textContent = c.cta;
      mailQuote(spec, c);
    });
  }
  function showOkCustom(title, body, note) {
    $("ok-title").textContent = title;
    $("ok-body").textContent = body;
    $("ok-note").textContent = note || "";
    $("ok-close").textContent = t().commission.close;
    $("ok-modal").classList.add("open"); $("ok-scrim").classList.add("open");
    $("ok-close").focus();
  }

  /* ============================================================
     CAREERS
     ============================================================ */
  function renderCareers() {
    if (!$("careers-in")) return;
    var c = t().careers;
    $("careers-in").innerHTML = head(c.eyebrow, c.h, c.body) +
      '<div class="car-grid">' +
      '<div class="car-points"><p class="flabel">' + c.what + "</p>" +
      c.points.map(function (p) {
        return '<div class="car-pt"><h3>' + p.t + "</h3><p>" + p.b + "</p></div>";
      }).join("") + "</div>" +
      '<div class="car-roles"><p class="flabel">' + c.rolesT + "</p><ul>" +
      c.roles.map(function (r) { return "<li>" + r + "</li>"; }).join("") +
      "</ul></div></div>" +

      '<div class="car-form"><h3 class="display">' + c.formT + "</h3>" +
      '<p class="body-copy">' + c.formB + "</p>" +
      '<form id="aform" novalidate><div class="form-grid">' +
      fld("a-name", c.fName, '<input id="c-a-name" name="name" autocomplete="name" required>') +
      fld("a-email", c.fEmail, '<input id="c-a-email" name="email" type="email" autocomplete="email" required>') +
      fld("a-phone", c.fPhone, '<input id="c-a-phone" name="phone" type="tel" autocomplete="tel">') +
      fld("a-role", c.fRole, '<select id="c-a-role" name="role">' +
        c.roles.map(function (r) { return '<option value="' + esc(r) + '">' + r + "</option>"; }).join("") +
        "</select>") +
      fld("a-links", c.fLinks, '<input id="c-a-links" name="links" inputmode="url">', c.fLinksHint, true) +
      fld("a-note", c.fNote, '<textarea id="c-a-note" name="note" rows="4"></textarea>', c.fNoteHint, true) +
      fld("a-file", c.fFile,
        '<div class="filewrap"><label class="filebtn" for="c-a-file">&#43; ' + c.fFilePick +
        '</label><input id="c-a-file" name="resume" type="file" class="sr"' +
        ' accept=".pdf,.doc,.docx,application/pdf,application/msword,' +
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document">' +
        '<span class="filename" id="a-filename"></span></div>', c.fFileHint, true) +
      '<div class="field full" aria-hidden="true" style="position:absolute;left:-9999px">' +
      '<label for="c-a-company">Company</label>' +
      '<input id="c-a-company" name="company" tabindex="-1" autocomplete="off"></div>' +
      "</div>" +
      '<div class="form-foot"><button class="btn btn-gold" id="a-submit" type="submit">' + c.send + "</button>" +
      '<span class="fmsg" id="a-msg"></span></div>' +
      '<p class="note car-privacy">' + c.privacy + "</p>" +
      "</form></div>";
    wireCareers();
  }
  function wireCareers() {
    var form = $("aform"), file = $("c-a-file"), c = t().careers;
    if (!form) return;
    file.addEventListener("change", function () {
      $("a-filename").textContent =
        file.files && file.files[0] ? c.fFileChosen + ": " + file.files[0].name : "";
    });
    form.addEventListener("submit", function (e) { e.preventDefault(); submitCareers(); });
  }
  function submitCareers() {
    var c = t().careers, msg = $("a-msg"), btn = $("a-submit");
    var v = {
      name: $("c-a-name").value.trim(), email: $("c-a-email").value.trim(),
      phone: $("c-a-phone").value.trim(), role: $("c-a-role").value,
      links: $("c-a-links").value.trim(), note: $("c-a-note").value.trim(),
      company: $("c-a-company") ? $("c-a-company").value : "",
      lang: lang, page: location.href
    };
    var file = $("c-a-file").files && $("c-a-file").files[0];
    var bad = [];
    if (!v.name) bad.push("a-name");
    if (!v.email || v.email.indexOf("@") < 1) bad.push("a-email");
    if (!file) bad.push("a-file");
    document.querySelectorAll("#aform .field").forEach(function (el) {
      el.classList.toggle("err", bad.indexOf(el.dataset.f) > -1);
    });
    if (bad.length) {
      msg.textContent = !v.name ? c.errName
        : (!v.email || v.email.indexOf("@") < 1) ? c.errEmail : c.errResume;
      return;
    }
    if (file.size > 8 * 1024 * 1024) { msg.textContent = c.errFile; return; }
    msg.textContent = "";

    if (!ARA_API) {
      location.href = "mailto:" + INBOX + "?subject=" +
        encodeURIComponent("Application — " + v.role) + "&body=" +
        encodeURIComponent(v.name + "\n" + v.email + "\n" + v.phone + "\n" +
          v.links + "\n\n" + v.note + "\n\n(Please attach your resume.)");
      return;
    }
    btn.textContent = c.sending; btn.disabled = true;
    readAttachment(file)
      .then(function (att) {
        if (att) v.attachment = att;
        return fetch(ARA_API + "/careers", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify(v)
        });
      })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || !j.ok) throw new Error(j.error || r.status);
          return j;
        });
      })
      .then(function () {
        showOkCustom(c.okTitle, c.okBody, "");
        $("aform").reset(); $("a-filename").textContent = "";
      })
      .catch(function () { msg.textContent = c.errFile; })
      .then(function () { btn.textContent = c.send; btn.disabled = false; });
  }

  /* ============================================================
     THE CABINET — finished pieces, in transit
     ============================================================ */
  function renderCabinet() {
    if (!$("cabinet-in")) return;
    var c = t().cabinet;
    $("cabinet-in").innerHTML = head(c.eyebrow, c.h) +
      '<div class="soon-card live-card"><span class="soon-badge on"><i></i>' + c.soon + "</span>" +
      "<p>" + c.body + "</p>" +
      '<div class="soon-cta">' + ttBtn(c.cta, c.ctaSub) +
      '<a class="btn btn-ghost" href="' + P("custom") + '#commission">' + c.alt + "</a></div></div>";
  }

  /* ============================================================
     THE JOURNAL — Shopify writes the posts; this renders them.
     window.ARA_POSTS is set by blog.liquid in the theme. Locally
     there are none, so the page says so rather than faking three.
     ============================================================ */
  function renderJournal() {
    if (!$("journal-in")) return;
    var j = t().journal, posts = window.ARA_POSTS || [];
    $("journal-in").innerHTML = head(j.eyebrow, j.h, j.body) +
      (posts.length
        ? '<div class="posts">' + posts.map(function (p) {
            return '<a class="post" href="' + p.url + '">' +
              (p.image ? '<span class="post-img"><img src="' + p.image +
                '" loading="lazy" decoding="async" alt="' + esc(p.title) + '"></span>' : "") +
              '<span class="post-body"><span class="post-date">' + esc(p.date || "") + "</span>" +
              "<h3>" + esc(p.title) + "</h3><p>" + esc(p.excerpt || "") + "</p>" +
              '<span class="callout-go"><i></i><span class="arw">&#8594;</span></span>' +
              "</span></a>";
          }).join("") + "</div>"
        : '<div class="soon-card live-card"><span class="soon-badge on"><i></i>' + j.soon + "</span>" +
          "<p>" + j.empty + "</p>" +
          '<div class="soon-cta">' + ttBtn(t().cabinet.cta, t().cabinet.ctaSub, true) +
          '<a class="btn btn-gold" href="' + P("custom") + '#commission">' + j.cta + "</a></div></div>");
  }

  /* The confirmation modal lives in every page's shell but is only written
     when something is sent. Left empty it is a blank heading in the DOM on
     every page, so it is primed at render and rewritten on use. */
  function primeModal() {
    if (!$("ok-title")) return;
    var f = t().commission;
    $("ok-title").textContent = f.okTitle;
    $("ok-body").textContent = f.okBody;
    $("ok-close").textContent = f.close;
  }

  /* The page takes the colour of the stone being looked at: the ambient
     light and the scroll rule both read --sel. Set once at render so the
     site is never sitting on a stale hue, and again on every swatch. */
  function paintSel(hex) {
    var r = parseInt(hex.substr(1, 2), 16), g = parseInt(hex.substr(3, 2), 16),
        b = parseInt(hex.substr(5, 2), 16), d = document.documentElement.style;
    d.setProperty("--sel", hex);
    d.setProperty("--sel-12", "rgba(" + r + "," + g + "," + b + ",.12)");
    d.setProperty("--sel-05", "rgba(" + r + "," + g + "," + b + ",.05)");
  }

  /* ============================================================
     RENDER + REVEAL
     ============================================================ */
  function renderAll() {
    document.documentElement.lang = lang;
    paintSel(color.hex);
    mountTints();
    renderNav(); renderPageHead(); renderHero(); renderPages(); renderWornBand();
    renderSelection(); renderUpclose();
    renderStone(); renderDays(); renderVocab(); renderCert();
    renderRecord(); renderBespoke(); renderCommission(); renderLive(); renderVault();
    renderWorn(); renderEthics(); renderFaq(); renderContact();
    renderConfig(); renderCareers(); renderCabinet(); renderJournal();
    renderFooter(); renderPamShell(); primeModal();
    watch(); luxe();
  }
  /* ============================================================
     LUXURY MOTION — aurora, hero tilt, image wipes
     ============================================================ */
  var luxed = false;
  function luxe() {
    /* the hero sits outside the .fade system, so it reveals itself */
    var he = $("hero-eyebrow"); if (he) he.classList.add("in");
    if (reduced || luxed) return;
    luxed = true;

    /* a slow gold light that follows the pointer */
    if (!$("aurora") && matchMedia("(pointer:fine)").matches) {
      var a = document.createElement("div");
      a.id = "aurora"; a.setAttribute("aria-hidden", "true");
      document.body.appendChild(a);
      var tx = innerWidth / 2, ty = innerHeight / 2, cx = tx, cy = ty, running = false;
      addEventListener("pointermove", function (e) {
        tx = e.clientX; ty = e.clientY;
        if (!a.classList.contains("on")) a.classList.add("on");
        if (!running) { running = true; requestAnimationFrame(drift); }
      }, { passive: true });
      function drift() {
        cx += (tx - cx) * 0.06; cy += (ty - cy) * 0.06;
        a.style.setProperty("--mx", cx + "px");
        a.style.setProperty("--my", cy + "px");
        if (Math.abs(tx - cx) > 0.4 || Math.abs(ty - cy) > 0.4) requestAnimationFrame(drift);
        else running = false;
      }
    }

    /* the hero stone answers the pointer */
    var stage = document.querySelector(".stone-stage");
    if (stage && matchMedia("(pointer:fine)").matches) {
      var main = stage.querySelector(".stone-main"), mini = stage.querySelector(".stone-mini");
      addEventListener("pointermove", function (e) {
        var dx = (e.clientX / innerWidth - 0.5), dy = (e.clientY / innerHeight - 0.5);
        if (main) main.style.translate = (dx * -18).toFixed(1) + "px " + (dy * -12).toFixed(1) + "px";
        if (mini) mini.style.translate = (dx * 26).toFixed(1) + "px " + (dy * 16).toFixed(1) + "px";
      }, { passive: true });
    }

    /* every photograph unveils rather than fades */
    document.querySelectorAll("#upclose img, #bespoke img, .stone-main, .stone-mini")
      .forEach(function (im) { im.classList.add("wipe"); });
    document.querySelectorAll(".stone-main, .stone-mini")
      .forEach(function (im) { setTimeout(function () { im.classList.add("in"); }, 120); });
  }

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
    });
  }, { threshold: 0.1, rootMargin: "0px 0px -5% 0px" });
  var REV = ".fade:not(.in),.rev:not(.in)";
  function watch() {
    document.querySelectorAll(REV).forEach(function (el) { io.observe(el); });
    /* anything already on screen reveals immediately, so the first painted
       frame — and any thumbnail taken of it — is never a blank page */
    setTimeout(function () {
      document.querySelectorAll(REV).forEach(function (el) {
        if (el.getBoundingClientRect().top < innerHeight) el.classList.add("in");
      });
    }, 60);
    /* and if the observer never fires at all, nothing stays hidden forever */
    setTimeout(function () {
      document.querySelectorAll(REV).forEach(function (el) {
        if (el.getBoundingClientRect().top < innerHeight * 1.5) el.classList.add("in");
      });
    }, 2500);
  }

  /* ============================================================
     EVENTS
     ============================================================ */
  document.addEventListener("click", function (e) {
    var el;
    if ((el = e.target.closest("[data-lang]"))) {
      lang = el.dataset.lang;
      document.querySelectorAll("#lang button").forEach(function (b) {
        b.setAttribute("aria-pressed", String(b.dataset.lang === lang));
      });
      try { localStorage.setItem("ara-lang", lang); } catch (_) { }
      renderAll(); return;
    }
    if ((el = e.target.closest("[data-c]"))) {
      color = COLORS.filter(function (c) { return c.key === el.dataset.c; })[0];
      paintSel(color.hex);
      paintFilters(); paintCuts(true); return;
    }
    if ((el = e.target.closest("[data-fs]"))) { fShape = el.dataset.fs; paintFilters(); paintCuts(true); return; }
    if ((el = e.target.closest("[data-step]"))) { step = +el.dataset.step; paintSteps(); return; }

    /* ---- the configurator ---- */
    if ((el = e.target.closest("[data-cm],[data-cp],[data-cs],[data-cb],[data-ck]"))) {
      if (el.getAttribute("aria-disabled") === "true") return;
      var d = el.dataset;
      if (d.cm) { cfg.metal = d.cm; }
      else if (d.cp) {
        /* a different piece asks different questions, so everything
           below it is cleared rather than silently carried over */
        if (cfg.piece !== d.cp) { cfg.style = null; cfg.back = null; }
        cfg.piece = d.cp;
        var only = byKey(TREE, d.cp);
        if (only && only.styles.length === 1) cfg.style = only.styles[0].k;
        if (only && only.noStone) cfg.band = null;
      }
      else if (d.cs) { cfg.style = d.cs; }
      else if (d.cb) { cfg.band = d.cb; }
      else { cfg.back = d.ck; }
      cfgOpts();
      /* the next unanswered question comes to the reader; once they are
         all answered, the price does */
      var st = steps(), nxt = null, i;
      for (i = 0; i < st.length; i++) if (!st[i].done) {
        nxt = document.querySelector('.cfg-step[data-s="' + st[i].q + '"]'); break;
      }
      var done = !nxt;
      if (done) nxt = $("cfg-plate");
      if (nxt && !reduced && nxt.getBoundingClientRect().bottom > innerHeight)
        nxt.scrollIntoView({ behavior: "smooth", block: done ? "end" : "center" });
      return;
    }
    if (e.target.closest("#cfg-go")) { cfgCheckout(); return; }
    if (e.target.closest("#cfg-reset")) {
      cfg = { metal: null, piece: null, style: null, band: null, back: null };
      cfgOpts();
      $("config").scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
      return;
    }

    if (e.target.closest("#drawer a")) { closeDrawer(); return; }
  });

  function closeDrawer() {
    $("drawer").classList.remove("open");
    $("burger").setAttribute("aria-expanded", "false");
  }
  $("burger").addEventListener("click", function () {
    var open = $("drawer").classList.toggle("open");
    $("burger").setAttribute("aria-expanded", String(open));
  });
  $("ok-close").addEventListener("click", closeOk);
  $("ok-scrim").addEventListener("click", closeOk);
  addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeOk(); pamOpen(false); closeDrawer(); }
  });
  addEventListener("scroll", function () {
    $("nav").classList.toggle("stuck", scrollY > 30);
  }, { passive: true });

  /* ---------------- hero light ---------------- */
  (function fire() {
    var c = $("fire-canvas");
    if (!c || reduced) return;
    var x = c.getContext("2d"), w, h, motes = [], raf;
    var hues = ["#C2A25F", "#E6D3A3", "#8A7440", "#F4F1EA"];
    function size() { var r = c.getBoundingClientRect(); w = c.width = r.width * devicePixelRatio; h = c.height = r.height * devicePixelRatio; }
    function seed() {
      motes = []; for (var i = 0; i < 34; i++) motes.push({
        x: Math.random() * w, y: Math.random() * h,
        r: (Math.random() * 80 + 26) * devicePixelRatio,
        vx: (Math.random() - .5) * .1 * devicePixelRatio, vy: (Math.random() - .5) * .1 * devicePixelRatio,
        c: hues[(Math.random() * hues.length) | 0], a: Math.random() * .12 + .04, p: Math.random() * 6.28
      });
    }
    function draw() {
      x.clearRect(0, 0, w, h); x.globalCompositeOperation = "lighter";
      for (var i = 0; i < motes.length; i++) {
        var m = motes[i];
        m.x += m.vx; m.y += m.vy; m.p += .005;
        if (m.x < -m.r) m.x = w + m.r; if (m.x > w + m.r) m.x = -m.r;
        if (m.y < -m.r) m.y = h + m.r; if (m.y > h + m.r) m.y = -m.r;
        var a = m.a * (0.55 + 0.45 * Math.sin(m.p));
        var g = x.createRadialGradient(m.x, m.y, 0, m.x, m.y, m.r);
        g.addColorStop(0, m.c + Math.round(a * 255).toString(16).padStart(2, "0"));
        g.addColorStop(1, m.c + "00");
        x.fillStyle = g; x.beginPath(); x.arc(m.x, m.y, m.r, 0, 7); x.fill();
      }
      raf = requestAnimationFrame(draw);
    }
    size(); seed(); draw();
    addEventListener("resize", function () { cancelAnimationFrame(raf); size(); seed(); draw(); });
  })();

  (function twinkles() {
    var stage = document.querySelector(".stone-stage"); if (!stage || reduced) return;
    [[18, 22, 15], [74, 14, 20], [62, 64, 13], [26, 72, 17], [88, 44, 11], [44, 38, 9]].forEach(function (s, i) {
      var d = document.createElement("i");
      d.className = "tw";
      d.style.cssText = "left:" + s[0] + "%;top:" + s[1] + "%;width:" + s[2] + "px;height:" + s[2] +
        "px;animation-delay:" + (i * .55) + "s";
      stage.appendChild(d);
    });
  })();

  /* ============================================================
     PAMELA
     ============================================================ */
  var BRIEF =
'You are Pamela, the concierge of The Ara Atelier, a New York City house that grows, cuts and sets laboratory diamonds. You are speaking to a visitor on the atelier\'s website. Answer ANY question they have about the house, diamonds, the process, certification, ordering, shipping or policy.\n\n' +
'VOICE: warm, unhurried, exact. Short paragraphs. Never salesy, no exclamation marks, no emoji. You know this trade from the bench up. If you genuinely do not know, say so and offer to put the question to the team.\n\n' +
'LANGUAGE: the visitor is browsing in %LANG%. Reply in that language unless they write in another, then match theirs.\n\n' +
'=== THE HOUSE ===\n' +
'The Ara Atelier, New York City. Laboratory-grown diamonds, every stone IGI certified and laser inscribed. Open every day; the team replies within 24 hours. Email info@thearaatelier.com. TikTok @the_ara_atelier. We sell LOOSE stones and make mountings to order. The online vault and the live broadcast calendar are COMING SOON — never invent a launch date.\n\n' +
'=== THE BOOK OF CUTS (39) ===\n' +
'Brilliant-faceted: round brilliant (57 facets), Portuguese (161), old European (58), oval (58), moval (58), pear (58), heart (59), marquise (58), Dutch marquise (58), trilliant (44), half moon (22).\n' +
'Step-faceted: emerald (58), asscher (58), sapphire cut (48), baguette (14), tapered baguette (14), oval step (34), moval step (34), marquise step (36), step cut pear (36), lozenge (24), hexagon (32), long hexagon (32), octagon (40), decagon (44), pentagon (28), kite (20), shield (24), cadillac (26), bullet (18), calf (16), Ashoka (62).\n' +
'Rose-faceted (flat back, domed faceted top): rose cut (24), rose pear (22).\n' +
'Mixed: princess (76), cushion (64), radiant (70).\n' +
'House shapes we are known for: kite, Dutch marquise, half moon, Portuguese.\n\n' +
'=== COLOR ===\n' +
'We work in white (D–J) and eight fancy colors: yellow, pink, blue, green, orange, purple, champagne, gray. Fancy intensity runs Fancy Light, Fancy, Fancy Intense, Fancy Vivid, Fancy Deep. Color is graded on hue, tone and saturation; saturation drives most of the value. A step cut shows color like a window; a brilliant breaks it into flashes. Nearly all our inventory is fancy color.\n\n' +
'=== THE HOUSE STANDARD ===\n' +
'Paper first: the report number is on screen from the first second. The right light: every stone is shown under ordinary light too, not only a lamp. No surprises later: what is on screen is what arrives in the box.\n\n' +
'=== HOW A STONE IS MADE (47-56 days seed to certificate) ===\n' +
'Seed prep and reactor load 1 day; growth 21-28 days; separation, mapping and marking 3; sawing, bruting and blocking 3; brillianteering and final polish 4-6; IGI certification 15. Growth: a seed wafer in a methane-hydrogen plasma at 900-1,200 C, carbon settling one atomic layer at a time, the plate re-polished by hand every few days. About 146 hours of skilled human attention per three-carat fancy shape, roughly 80 of them on the wheel.\n\n' +
'=== SCIENCE ===\n' +
'Same carbon lattice as mined, 10 on the Mohs scale, identical brilliance and fire. NOT moissanite, NOT cubic zirconia. Two growth methods, HPHT and CVD; the IGI report states which. A gemologist needs equipment to tell; by eye no one can.\n\n' +
'=== THE IGI REPORT ===\n' +
'Lines: Report Number, Laboratory Grown, Growth Method, Shape and Cutting Style, Color Grade, Carat Weight, Measurements, Clarity Grade, Cut/Polish/Symmetry, Fluorescence, Laser Inscription, Comments. Anyone can verify a report at igi.org under Report Check. Encourage it, during the live, before deciding.\n\n' +
'=== THE FOUR Cs ===\n' +
'Carat is weight not size (1 ct = 0.20 g). Color: D-Z for whites, the fancy scale for colors. Clarity: FL, IF, VVS, VS, SI, I, with a plot. Cut is the only one made by human hands.\n\n' +
'=== MADE TO ORDER ===\n' +
'No catalog. Send a sketch, screenshot or photograph. Solitaire, three-stone, halo, bezel, toi-et-moi, or something new. Solid gold — yellow, white or rose, never plated, never filled, never hollow. We will gladly set a stone the client already owns. Six steps: talk, sketch, CAD, wax, bench, check. Typically three to five weeks from approved CAD.\n' +
'PRICING: every commission is quoted INDIVIDUALLY. Never quote a mounting price, a stone price or a range — you do not have a price list. Point the visitor to the commission form on this page (or offer to open it) and say the team returns a quote within 24 hours.\n\n' +
'=== POLICY ===\n' +
'Auctions are final and do not reopen. Anything damaged, incomplete or materially other than described is put right without discussion — contact within seven days of delivery. Shipping is insured and tracked, worldwide; duties and import taxes outside the US are the buyer\'s responsibility. Made-to-order pieces are not returnable except where faulty. A laboratory diamond is NOT an investment — resale value is modest, and we say so plainly.\n\n' +
'=== TOOLS ===\n' +
'If the visitor asks to speak to a person, a representative, a human, sales or customer service — or asks for a quote, a callback, or to be contacted — collect their NAME and their EMAIL (a phone number is welcome too), then call request_representative. Ask for anything missing first; never call it without a name and an email. After it returns, confirm that the team will reach out within 24 hours.\n' +
'If they want to commission a piece or send a picture, call open_commission_form to take them to the form.\n\n' +
'RULES: keep replies under about 120 words unless asked for detail. Never invent a stone, a certificate number, a price, a discount or a delivery date. Never claim a stone is mined. If asked something outside diamonds and this house, answer briefly and bring it back.';

  var PAM = null, pamReady = false, pamTools = false, turns = [], busy = false, ctl = null;

  function renderPamShell() {
    if (!$("pam-log")) return;          /* not a section on this page */
    var p = t().pam;
    $("pam-title").textContent = p.title;
    $("pam-status").textContent = (pamReady && !PAM) ? p.offline : p.role;
    $("pam-input").placeholder = p.ph;
    $("pam-log").innerHTML = "";
    turns = [];
    bubble("bot", p.hello);
    $("pam-chips").innerHTML = p.chips.map(function (c) {
      return '<button type="button" data-chip="' + esc(c) + '">' + c + "</button>";
    }).join("");
  }
  function bubble(who, text) {
    var d = document.createElement("div");
    d.className = "msg " + who; d.textContent = text;
    $("pam-log").appendChild(d); $("pam-log").scrollTop = $("pam-log").scrollHeight;
    return d;
  }
  function pamOpen(o) {
    $("pam-panel").classList.toggle("open", o);
    $("pam-badge").style.display = o ? "none" : "block";
    if (o) setTimeout(function () { $("pam-input").focus(); }, 320);
  }
  $("pam-fab").addEventListener("click", function () {
    pamOpen(!$("pam-panel").classList.contains("open"));
  });
  $("pam-close").addEventListener("click", function () { pamOpen(false); });
  $("pam-chips").addEventListener("click", function (e) {
    var b = e.target.closest("[data-chip]"); if (!b) return;
    $("pam-input").value = b.dataset.chip;
    $("pam-form").requestSubmit();
  });

  /* Pamela has two ways to reach a model and takes whichever exists.
     On claude.ai the page is granted a sampling capability directly. On
     Shopify — or anywhere else — she goes through the Ara Worker, which
     holds the API key server-side where a visitor cannot read it. Both
     present the same call signature, so nothing below this point cares
     which one is in use. */
  var pamNeedsBrief = true;

  function workerPam() {
    pamNeedsBrief = false;
    return function (messages, opts) {
      opts = opts || {};
      var turns = messages.filter(function (m) { return m.role !== "system"; });
      return fetch(ARA_API + "/pamela", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        signal: opts.signal,
        body: JSON.stringify({ lang: lang, messages: turns })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || !j.ok) {
            var e = new Error(j.error || "upstream");
            e.code = j.error === "rate_limited" ? "rate_limited"
                   : j.error === "not_configured" ? "not_granted" : "error";
            throw e;
          }
          (j.actions || []).forEach(runAction);
          return { text: j.text || "" };
        });
      });
    };
  }

  function runAction(a) {
    if (!a) return;
    if (a.type === "lead_captured") { bubble("sys", t().pam.leadOk); return; }
    if (a.type === "open_commission_form") {
      var p = a.prefill || {};
      if (p.name && $("c-name")) $("c-name").value = p.name;
      if (p.email && $("c-email")) $("c-email").value = p.email;
      if (p.details && $("c-details")) $("c-details").value = p.details;
      if (p.piece && $("c-piece")) {
        [].slice.call($("c-piece").options).forEach(function (o) {
          if (o.value.toLowerCase() === String(p.piece).toLowerCase()) $("c-piece").value = o.value;
        });
      }
      $("commission").scrollIntoView({ behavior: "smooth", block: "start" });
      pamOpen(false);
    }
  }

  (function initPam() {
    var done = function () {
      if (!PAM && ARA_API) PAM = workerPam();      /* the Shopify path */
      pamReady = true;
      if (!PAM) $("pam-status").textContent = t().pam.offline;
    };
    try {
      if (window.claude && claude.use) {
        claude.use("sample").then(function (s) {
          PAM = s;
          if (s && s.limits) {
            s.limits().then(function (L) { pamTools = !!(L && L.tools); done(); }, done);
          } else done();
        }, done);
      } else done();
    } catch (_) { done(); }
  })();

  function leadTools() {
    return [
      {
        name: "request_representative",
        description: "Record a visitor's request to be contacted by a human member of the Ara Atelier team. Requires their name and email.",
        inputSchema: {
          type: "object",
          properties: {
            name: { type: "string", description: "The visitor's full name" },
            email: { type: "string", description: "The visitor's email address" },
            phone: { type: "string", description: "Phone or WhatsApp, if given" },
            topic: { type: "string", description: "What they want to discuss, in one line" }
          },
          required: ["name", "email"]
        },
        execute: function (input) {
          var body =
            "Name: " + (input.name || "") + "\n" +
            "Email: " + (input.email || "") + "\n" +
            "Phone: " + (input.phone || "—") + "\n" +
            "Topic: " + (input.topic || "Requested a representative") + "\n\n" +
            "Captured by Pamela on " + location.href;
          sendLead("Website Inquiry — representative requested", body);
          bubble("sys", t().pam.leadOk);
          return { status: "received", promise: "Team will reach out within 24 hours." };
        }
      },
      {
        name: "open_commission_form",
        description: "Take the visitor to the commission form on this page and prefill what is known.",
        inputSchema: {
          type: "object",
          properties: {
            name: { type: "string" }, email: { type: "string" },
            piece: { type: "string", description: "Ring, Pendant, Earrings or Bracelet" },
            details: { type: "string" }
          }
        },
        execute: function (input) {
          if (input.name && $("c-name")) $("c-name").value = input.name;
          if (input.email && $("c-email")) $("c-email").value = input.email;
          if (input.details && $("c-details")) $("c-details").value = input.details;
          if (input.piece && $("c-piece")) {
            [].slice.call($("c-piece").options).forEach(function (o) {
              if (o.value.toLowerCase() === String(input.piece).toLowerCase()) $("c-piece").value = o.value;
            });
          }
          document.getElementById("commission").scrollIntoView({ behavior: "smooth", block: "start" });
          pamOpen(false);
          return { status: "opened" };
        }
      }
    ];
  }
  function sendLead(subject, body) {
    if (ARA_API) {
      fetch(ARA_API + "/inquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: (body.match(/Name:\s*(.+)/) || [])[1] || "Pamela lead",
          email: (body.match(/Email:\s*(.+)/) || [])[1] || "",
          details: body, lang: lang, page: location.href
        })
      }).catch(function () { });
    } else {
      var a = document.createElement("a");
      a.href = "mailto:" + INBOX + "?subject=" + encodeURIComponent(subject) +
        "&body=" + encodeURIComponent(body);
      a.style.display = "none"; document.body.appendChild(a); a.click(); a.remove();
    }
  }

  $("pam-form").addEventListener("submit", function (e) {
    e.preventDefault();
    var input = $("pam-input"), text = input.value.trim(), p = t().pam;
    if (!text || busy) return;
    input.value = "";
    bubble("me", text);
    $("pam-chips").innerHTML = "";

    if (!PAM) {
      if (!pamReady) {
        var wait = bubble("sys", p.connecting);
        setTimeout(function () { wait.remove(); bubble("bot", PAM ? "" : p.noReach); }, 1400);
      } else bubble("bot", p.noReach);
      return;
    }

    busy = true;
    var out = bubble("bot", "");
    out.innerHTML = '<span class="dots"><i></i><i></i><i></i></span>';
    turns.push({ role: "user", content: text });
    if (turns.length > 14) turns.splice(0, turns.length - 14);
    ctl = new AbortController();

    var opts = {
      cache: false, signal: ctl.signal,
      onText: function (u) { out.textContent = u.text; $("pam-log").scrollTop = $("pam-log").scrollHeight; }
    };
    if (pamTools) opts.tools = leadTools();

    /* The Worker holds the brief server-side; the sample capability needs it
       passed in with every call. */
    var payload = pamNeedsBrief
      ? [{ role: "user", content: BRIEF.replace("%LANG%", lang === "es" ? "Spanish" : "English") }].concat(turns)
      : turns.slice();

    PAM(payload, opts)
      .then(function (r) {
        out.textContent = r.text;
        turns.push({ role: "assistant", content: r.text });
      }, function (err) {
        if (err && err.code === "cancelled") out.remove();
        else if (err && err.code === "not_granted") out.textContent = p.notGranted;
        else if (err && err.code === "rate_limited") out.textContent = p.rateLimited;
        else out.textContent = (err && err.text) || p.generic;
      }).then(function () {
        busy = false; $("pam-log").scrollTop = $("pam-log").scrollHeight;
      });
  });

  /* ============================================================
     BOOT
     ============================================================ */
  try {
    var saved = localStorage.getItem("ara-lang");
    if (saved === "es" || saved === "en") lang = saved;
  } catch (_) { }
  if (/[?&]lang=es/.test(location.search)) lang = "es";
  document.querySelectorAll("#lang button").forEach(function (b) {
    b.setAttribute("aria-pressed", String(b.dataset.lang === lang));
  });
  document.documentElement.style.setProperty("--sel", color.hex);
  renderAll();
})();
